import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=3506f8b3&scoped=true&"
import script from "./DashboardHome.vue?vue&type=script&lang=js&"
export * from "./DashboardHome.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHome.vue?vue&type=style&index=0&id=3506f8b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506f8b3",
  null
  
)

export default component.exports